export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Colors.vue?vue&type=template&id=2c10b932&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Styles/Colors.vue?vue&type=template&id=2c10b932&scoped=true&
// module id = null
// module chunks = 